import React, { useCallback, useState } from 'react';
import callBackendAPI from '../../utils/callBackendAPI';
import { useNavigate } from 'react-router-dom';
import SigninForm from './form/SigninForm';

interface IProps {
  modalClosedSignIn: () => void;
  modalClosedSignUp: () => void;
}

const SignIn = (props: IProps) => {
  const { modalClosedSignIn, modalClosedSignUp } = props;
  const [userEmail, setuserEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();

  const onModalClosedSignIn = useCallback(() => {
    modalClosedSignIn();
    // navigate('/');
  }, [modalClosedSignIn]);

  const onModalClosedSignUp = useCallback(() => {
    modalClosedSignUp();
  }, [modalClosedSignUp]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoginError(() => '');
    try {
      const response = await callBackendAPI('POST', 'auth/login', null, {
        userEmail,
        password,
      });
      if (response.error) {
        setLoginError(() => response.error);
      } else {
        const { token, userData } = await response.data;
        userData.isAuthenticated = true;
        localStorage.setItem('accessToken', token);
        localStorage.setItem('user', JSON.stringify(userData));
        // localStorage.setItem('isLoggedin', 'true');
        navigate('/dashboard');
      }
    } catch (error) {
      setLoginError(() => 'something went wrong!!!');
      console.error('Sign in failed:', error);
    }
  };

  return (
    <>
      <SigninForm
        submitHandler={handleSubmit}
        onModalClosedSignIn={onModalClosedSignIn}
        onModalClosedSignUp={onModalClosedSignUp}
        initialValues={{ Email: '', Password: '' }}
        isLoading={false}
        setLoginError={setLoginError}
        loginError={loginError}
      />
    </>
  );
};

export default SignIn;